import { useMutation } from "@tanstack/react-query";
import { UnknownFund } from "src/pages/Admin/UnknownFunds/types";
import { UnknownSecurities } from "src/pages/Admin/UnknownSecurities/Type";

import { apiClient } from "../../config/apiClient";
import { API } from "../../config/apiConfig";

async function mapUnknownSecurityRequest({
	securityId,
	isin,
	tickerSymbol,
	name,
	exchange,
	currency
}: UnknownSecurities) {
	return await apiClient
		.post(API.COMMAND.ADMIN.UNKOWN_SECURITIES(securityId), {
			securityId,
			isin,
			tickerSymbol,
			name,
			exchange,
			currency
		})
		.then((res) => res.data);
}

export function useMapUnknownSecurity(onSuccess: () => void, onError: () => void) {
	return useMutation({
		mutationFn: (sec: UnknownSecurities) => mapUnknownSecurityRequest(sec),
		onSuccess,
		onError
	});
}

async function saveUnknownFundRequest({ id, managementCompany, spanishTaxExempt }: UnknownFund) {
	return await apiClient
		.put(API.COMMAND.ADMIN.UNKOWN_FUNDS(id), {
			managementCompany,
			taxExempt: spanishTaxExempt
		})
		.then((res) => res.data);
}

export function useSaveUnknownFund(onSuccess: () => void, onError: () => void) {
	return useMutation({
		mutationFn: (sec: UnknownFund) => saveUnknownFundRequest(sec),
		onSuccess,
		onError
	});
}
